import React from "react";
import {Link} from "react-router-dom";
import Modal from "../../Modal";

const Lichaam = () => {
    const Avatar = ({alt, color, src}) => (
        <div className={`avatar avatar-${color}`}>
            <img src={src} alt={alt}/>
        </div>
    );

    const BlueAvatar = (props) => (<Avatar color={'blue'} {...props} />);
    const AquaAvatar = (props) => (<Avatar color={'aqua'} {...props} />);
    const GreenAvatar = (props) => (<Avatar color={'green'} {...props} />);
    const OrangeAvatar = (props) => (<Avatar color={'orange'} {...props} />);
    const PurpleAvatar = (props) => (<Avatar color={'purple'} {...props} />);

    return (
        <Modal title={'Wat is kindermishandeling?'}
               image={'https://care-free.app/wp-content/uploads/2024/01/Hoowy_Lichaam_RolloverActive.png'}>
            <div>
                <p>
                    Jaarlijks hebben <b>119.000 kinderen</b> te maken met <b>kindermishandeling</b>. Een <b>scholierenonderzoek</b> zegt dat <b>bijna 27 procent</b> van de leerlingen in <b>groep 7 en 8</b> en <b>bijna 25 procent</b> van de leerlingen in de <b>eerste vier leerjaren van het voortgezet onderwijs</b> met een of meerdere vormen van kindermishandeling te maken heeft gehad.
                </p>
                <p>
                    Volgens de <b>jeugdwet</b> is kindermishandeling: <b>"Elke vorm van voor een minderjarige bedreigende of gewelddadige interactie van fysieke, psychische of seksuele aard die de ouders of andere personen ten opzichte van wie de minderjarige in relatie van afhankelijkheid of van onvrijheid staat, actief of passief opdringen, waardoor ernstige schade wordt berokkend of dreigt te worden berokkend aan de minderjarige in de vorm van fysiek of psychisch letsel."</b>
                </p>

                <h2>SOORTEN KINDERMISHANDELING</h2>

                <p>
                    Er bestaan verschillende <b>soorten kindermishandeling.</b> Een kind kan met één of meerdere vormen tegelijkertijd te maken krijgen.
                </p>

                <h3>
                    LICHAMELIJKE MISHANDELING
                </h3>

                <div className={'avatars'}>
                    <BlueAvatar src={'https://care-free.app/wp-content/uploads/2024/01/Slaan_Schoppen.svg'}  alt={'Slaan, Schoppen'}/>
                    <BlueAvatar src={'https://care-free.app/wp-content/uploads/2024/01/Haren_Trekken.svg'}  alt={'Haren trekken'}/>
                    <BlueAvatar src={'https://care-free.app/wp-content/uploads/2024/01/Bijten.svg'}  alt={'Bijten'}/>
                    <BlueAvatar src={'https://care-free.app/wp-content/uploads/2024/01/Duwen.svg'}  alt={'Duwen'}/>
                </div>

                <p>
                    <b>
                        Wanneer iemand waar het kind afhankelijk van is het kind pijn doet op zijn/haar lichaam spreken we van lichamelijke mishandeling.
                    </b> Voorbeelden hiervan zijn: slaan en schoppen (met een voorwerp), haren trekken, duwen, krabben, knijpen, bijten en brandwonden toebrengen.
                </p>

                <p>
                    <b>Ook deze vormen vallen onder lichamelijke kindermishandeling:</b>
                    <ul>
                        <li>
                            <b>Het Shakenbabysyndroom </b>
                            waarbij een baby zo hard door elkaar wordt geschud dat hij daar hersenletsel aan overhoudt of zelfs overlijdt.
                        </li>
                        <li>
                            <b>Munchausen-by-Proxysyndroom </b>
                            waarbij ouders, meestal moeders, hun kind opzettelijk ziek maken of onnodige onderzoeken laten ondergaan.
                        </li>
                        <li>
                            <b>Meisjesbesnijdenis </b>
                            waarbij zonder medische noodzaak het geslachtsdeel wordt besneden of verwijderd.
                        </li>
                        <li>
                            <b>Mishandeling van het ongeboren kind </b>
                            waarbij de moeder tijdens de zwangerschap rookt, alcohol of drugs gebruikt. Ook veel ruzie, geweld en als de moeder niet goed voor zichzelf zorgt brengen risico’s met zich mee voor het ongeboren kind
                        </li>
                        <li>
                            <b>Eergerelateerd geweld </b>
                            waarbij vanuit collectieve mentaliteit geweld wordt gebruikt in reactie op een dreiging van de eer van een man/vrouw en daarmee van zijn/haar familie, waarvan de buitenwereld op de hoogte is of dreigt te raken.
                        </li>
                    </ul>
                </p>

                <h3>
                    EMOTIONELE MISHANDELING
                </h3>

                <div className={'avatars'}>
                    <GreenAvatar src={'https://care-free.app/wp-content/uploads/2024/01/Schreeuwen.svg'}  alt={'Schreeuwen'}/>
                    <GreenAvatar src={'https://care-free.app/wp-content/uploads/2024/01/Negeren.svg'}  alt={'Negeren'}/>
                    <GreenAvatar src={'https://care-free.app/wp-content/uploads/2024/01/Langdurig_hoge_verwachtingen.svg'}  alt={'Langdurig hoge verwachtingen'}/>
                    <GreenAvatar src={'https://care-free.app/wp-content/uploads/2024/01/Naar_beneden_halen.svg'}  alt={'Naar beneden halen'}/>
                </div>

                <p>
                    <b> Wanneer ouders of andere opvoeders structureel en langdurig te weinig/geen aandacht hebben voor het kind spreken we van emotionele mishandeling.</b> Je kunt dit ook emotionele verwaarlozing noemen. <b>Veelvuldig uitschelden, schreeuwen, kleineren en overvragen vallen ook onder emotionele mishandeling.</b> Dit kan door ouders/ opvoeders maar ook door een ander persoon gebeuren waar het kind afhankelijk van is.
                </p>

                <h3>
                    LICHAMELIJKE VERWAARLOZING
                </h3>

                <div className={'avatars'}>
                    <AquaAvatar src={'https://care-free.app/wp-content/uploads/2024/01/Kleine_kapotte_kleding.svg'}  alt={'Kleine kapotte kleding'}/>
                    <AquaAvatar src={'https://care-free.app/wp-content/uploads/2024/01/Honger_hebben.svg'}  alt={'Honger hebben'}/>
                    <AquaAvatar src={'https://care-free.app/wp-content/uploads/2024/01/Dokter_ontzeggen.svg'}  alt={'Dokter ontzeggen'}/>
                    <AquaAvatar src={'https://care-free.app/wp-content/uploads/2024/01/DakBovenHoofd.svg'}  alt={'Dak boven hoofd'}/>
                    <AquaAvatar src={'https://care-free.app/wp-content/uploads/2024/01/Onderwijs.svg'}  alt={'Onderwijs'}/>
                    <AquaAvatar src={'https://care-free.app/wp-content/uploads/2024/01/VrijeTijd.svg'}  alt={'Vrije tijd'}/>
                </div>

                <p>
                    <b>Kinderen hebben recht op voldoende eten en drinken, gepaste kleding, onderwijs, vrije tijd en een dak boven het hoofd.</b> Ook hebben kinderen <b>recht op zorg</b> in de vorm van aandacht, maar ook dat ze geholpen worden en naar een dokter of tandarts kunnen gaan of andere hulp krijgen als zij dat nodig hebben. Het kan voorkomen dat een ouder/verzorger (tijdelijk) niet kan zorgen voor deze rechten. Als dat het geval is bestaat er hulp zodat kinderen daar geen last van hoeven te krijgen.
                </p>

                <h3>
                    SEKSUEEL MISBRUIK
                </h3>

                <div className={'avatars'}>
                    <OrangeAvatar src={'https://care-free.app/wp-content/uploads/2024/02/Ongewenst_aanraken.svg'}  alt={'Ongewenst aanraken'}/>
                    <OrangeAvatar src={'https://care-free.app/wp-content/uploads/2024/02/Ongewenst_kussen.svg'}  alt={'Ongewenst kussen'}/>
                    <OrangeAvatar src={'https://care-free.app/wp-content/uploads/2024/02/Ongewenst_vrijen.svg'}  alt={'Ongewenst vrijen'}/>
                    <OrangeAvatar src={'https://care-free.app/wp-content/uploads/2024/02/Toekijken_vrijen.svg'}  alt={'Toekijken vrijen'}/>
                    <OrangeAvatar src={'https://care-free.app/wp-content/uploads/2024/01/OnlineSeksueelMisbruik.svg'}  alt={'Online seksueel misbruik'}/>
                </div>

                <p>
                    <b>Er is sprake van seksueel misbruik als het kind aangeraakt wordt op plekken waar hij/zij dat niet wil en waar dat niet gepast is.</b> Wanneer een kind moet toekijken terwijl er seksuele handelingen plaatsvinden tussen anderen valt dit onder seksueel misbruik. Ook wanneer iemand waar het kind afhankelijk van is online seksueel getinte dingen vraagt of stuurt die niet gepast zijn spreken we van seksueel misbruik.
                </p>

                <h3>
                    HUISELIJK GEWELD
                </h3>

                <div className={'avatars'}>
                    <PurpleAvatar src={'https://care-free.app/wp-content/uploads/2024/01/Getuige_Huiselijk_Geweld.svg'}  alt={'Getuige huiselijk geweld'}/>
                </div>

                <p>
                    <b>Als een kind ziet dat een ander met lichamelijke mishandeling, emotionele mishandeling, lichamelijke verwaarlozing en/of seksueel misbruik te maken heeft in de situatie waar hij/zij woont of veel verblijft is het kind getuige van huiselijk geweld.</b> Vechtscheidingen en partnergeweld zijn hier voorbeelden van. Doordat het kind zich door deze situaties onveilig, verdrietig, bang of misschien wel boos gaat voelen hoort deze vorm ook bij kindermishandeling.
                </p>
            </div>
        </Modal>
    );
}


export default Lichaam;
